export const SALUTATIONS = ["Mr", "Mrs", "Ms", "Mdm", "Dr", "Prof"];

export const withSalutation = (r) =>
  [r?.salutation, r?.first_name, r?.last_name].filter(Boolean).join(" ");
